<div class="container">
  <div class="close" (click)="closeDialog()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>

  <h1 class="title">Confirmar {{ data.type ? 'compra' : 'venta' }}</h1>

  <div class="receive">
    <h3 class="receive-title">Vas a recibir</h3>
    <h1 class="receive-data">
      {{ data.destAmount | formatCoinAmount: data.destCoin }} {{ data.destCoin }}
    </h1>
  </div>

  <div class="price">
    <div class="total">
      <p class="text">Total</p>
      <p class="amount">{{ data.srcAmount | formatCoinAmount: data.srcCoin }} {{ data.srcCoin }}</p>
    </div>
    <div class="rate">
      <p class="text">Cotización</p>
      <p class="amount">{{ data.price | formatCoinAmount: data.fiatCoin }} {{ data.fiatCoin }}</p>
    </div>
  </div>

  <div class="buttons">
    <button
      *ngIf="!isProcessing; else trxProcessing"
      class="td-btn"
      [class.disabled]="!firstLockPriceDone"
      (click)="handleOrder()"
    >
      {{ firstLockPriceDone ? data.options[0] : 'Obteniendo precio' }}
    </button>
    <ng-template #trxProcessing>
      <div class="loading">
        <div class="circle-loader">
          <div class="checkmark draw"></div>
        </div>
      </div>
    </ng-template>
  </div>

  <p class="price-timer" *ngIf="showCountDownSecond">Oferta válida por {{ countDownSecond }}s</p>
  <p class="price-timer" *ngIf="data.code && !showCountDownSecond">Oferta caducada</p>
</div>
